import { Injectable } from '@angular/core';
import { EmploymentObject, EmploymentTypeGridObject, OkObject } from '@it2go/types';
import { employmentFrag } from './types/user.types';
import { CreateEmploymentInput } from '@libs/types/src/user/input-type/create-employment.input';
import { filterFrag } from './types/filter.types';
import { GridInput } from '@it2go/data-grid';
import { EmploymentGridObject } from '@libs/types/src/user/object-type/employment-grid.object';
import { UpdateEmploymentInput } from '@libs/types/src/user/input-type/update-employment.input';
import { GqlQueryOptions, GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { IdInput } from '@libs/types/src/common/input-type/id.input';

@Injectable({ providedIn: 'root' })
export class EmploymentGqlService extends GqlServiceV2 {

    createEmployment(input: CreateEmploymentInput) {
        return this.mutate<EmploymentObject>(
            `
                mutation($input: CreateEmploymentInput!) {
                    employment {
                        create(input: $input) {
                            ${employmentFrag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    updateEmployment(input: UpdateEmploymentInput) {
        return this.mutate<EmploymentObject>(
            `
                mutation($input: UpdateEmploymentInput!) {
                    employment {
                        update(input: $input) {
                            ${employmentFrag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getEmploymentTypes(input: GridInput, fragment: string) {
        return this.query<EmploymentTypeGridObject>(
            `
                query($input: GridInput) {
                    employmentType {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getEmployments(input: GridInput, fragment: string, options: GqlQueryOptions = {}) {
        return this.query<EmploymentGridObject>(
            `
                query($input: GridInput) {
                    employment {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
            options,
        );
    }

    public async getEmploymentsPublicFilter(input: GridInput, fragment: string): Promise<EmploymentGridObject> {
        return this.query<EmploymentGridObject>(
            `
                query($input: GridInput!) {
                    employment {
                        publicFilter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteEmployment(input: IdInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    employment {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

}
